import React, { useState } from "react";

import { GenericLogs } from "../../../../components/GenericLogs/GenericLogs";
import { fetchCohortLogs, fetchCohortLogsDetailed } from "./CohortLogs.function";
import { transformCohortLog } from "./CohortLogs.transform";

const CohortLogs = ({ cohortId, language }: { cohortId: string; language: string }) => {
  const [detailed, setDetailed] = useState(false);

  return (
    <GenericLogs
      key={detailed ? "detailed" : "simple"}
      entityId={cohortId}
      language={language}
      fetchLogs={detailed ? fetchCohortLogsDetailed : fetchCohortLogs}
      translationPrefix="PAGES.COHORT.LOGS.ATTRIBUTES"
      detailedConfig={{
        enabled: true,
        value: detailed,
        onToggle: () => setDetailed((prev) => !prev),
      }}
      transformDetailedLog={transformCohortLog}
    />
  );
};

export default CohortLogs;
